import {getEnv} from '../common/env/env';
import {ServerEnv} from '../common/env/ServerEnv.enum';
import {IS_CLIENT_SIDE} from '../common/shared/utils/constants';

let initPromise: Promise<void> | null = null;

export function initTiara(): Promise<void> {
  if (window.TiaraTracker || !IS_CLIENT_SIDE) {
    return Promise.resolve();
  }

  // 중복 로드 방지
  if (initPromise) {
    return initPromise;
  }

  initPromise = new Promise<void>((resolve, reject) => {
    const se = document.createElement('script');
    se.type = 'text/javascript';
    se.async = true;
    se.src =
      location.protocol + '//t1.kakaocdn.net/tiara/js/v1/tiara-1.2.0.min.js';
    se.onload = event => {
      try {
        window.TiaraTracker.getInstance().init({
          svcDomain: 'page.kakao.com',
          deployment:
            getEnv().envName === ServerEnv.Real ? 'production' : 'dev',
        });
        resolve();
      } catch (e) {
        console.error('eeeee', e);
        reject(e);
      }
    };
    document.head.appendChild(se);
  });

  return initPromise;
}
